/**
 * Forced-logout reason relay.
 *
 * When the app ends a session FOR the user (access token revoked from another
 * device / by an admin, or the refresh token expired) it stashes a reason code
 * here, so the sign-in screen can explain WHY instead of silently dumping the
 * user at /signin mid-task. Uses sessionStorage so the message survives the
 * full-page reload that some logout paths trigger (window.location redirect).
 *
 * Not set for user-initiated logout (no explanation needed) or first-load
 * "no session yet" (the user wasn't signed out — they were never in).
 */
const KEY = 'cts.signout.reason';

export const SIGN_OUT_MESSAGES = {
  revoked: 'You were signed out because your session was ended. Please sign in again.',
  expired: 'Your session expired. Please sign in again.',
};

/** Record why the session is ending. No-op for an unknown code. */
export function setSignOutReason(code) {
  try {
    if (SIGN_OUT_MESSAGES[code]) sessionStorage.setItem(KEY, code);
  } catch {
    /* sessionStorage unavailable (private mode / SSR) — degrade silently */
  }
}

/** Read AND clear the pending reason, returning its message (or null if none). */
export function takeSignOutReason() {
  try {
    const code = sessionStorage.getItem(KEY);
    if (code) sessionStorage.removeItem(KEY);
    return SIGN_OUT_MESSAGES[code] ?? null;
  } catch {
    return null;
  }
}
